import React from 'react';
import { Page } from '../Page';
import { Heart, Brain, Shield } from 'lucide-react';
export function SupplementOmega3() {
  return <Page pageNumber={17} variant="light" data-id="element-3287" data-mp="1b3szssf0vtnt">
      <div className="flex h-full gap-10" data-id="element-3288" data-mp="1p1zqnolk0tdz">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3289" data-mp="1ozwq4amrzhv0">
          <img src="https://cdn.magicpatterns.com/uploads/3KbmboHJcX9JxXqrqDKoJB/pasted-image.png" alt="Thorne Omega-3 with CoQ10" className="w-full max-w-[280px] object-contain" data-id="element-3290" data-mp="1k1bqacbfr073" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3291" data-mp="27sqy2klze9pq">
          <div className="mb-6 pt-4" data-id="element-3292" data-mp="27ulkk3cwi9vx">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3293" data-mp="22sw76h27hk4o">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3294" data-mp="2hqwvaowuero9">
              Omega-3 with CoQ10
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3295" data-mp="gvcjwnuqu0qu">
              Anti-inflammatory + cardiovascular protection
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3296" data-mp="lupho3n5ks87" />
          </div>

          <div className="mb-8" data-id="element-3297" data-mp="pvhqwww0yx4h">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3298" data-mp="pu7u0b0wruzf">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3299" data-mp="zu6x3sek6t4w">
              Rapid weight loss triggers an inflammatory response throughout the
              body. Omega-3 fatty acids (EPA + DHA) support a healthy
              inflammatory response, protect cardiovascular health, and maintain
              brain function during caloric deficit. The added CoQ10 enhances
              absorption and provides synergistic cellular energy support.
            </p>
          </div>

          <div className="mb-8" data-id="element-3300" data-mp="1njj7gvlmh78s">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3301" data-mp="1nkkulyfwxk6v">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3302" data-mp="3jnfsjgirrb6g">
              <li className="flex gap-2" data-id="element-3303" data-mp="3eocmptuyt0xf">
                <Heart className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3304" data-mp="3epe9gvlcfbuz" />
                <span data-id="element-3305" data-mp="3td94wjqqjubr">
                  Supports cardiovascular health, promoting healthy blood vessel
                  function, cholesterol, and triglyceride levels
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3306" data-mp="666pt6aixn5f">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3307" data-mp="266cjoz5vhzy" />
                <span data-id="element-3308" data-mp="288zg050ov0g">
                  Promotes a healthy inflammatory response during the metabolic
                  stress of weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3309" data-mp="b7e29inm3aif">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3310" data-mp="2hx2bk2x3v0pb" />
                <span data-id="element-3311" data-mp="2hz5c3gvvwc8a">
                  Supports brain function and protects against oxidative stress
                  during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3312" data-mp="sgymlie7yinv">
                <span className="text-tealslate shrink-0" data-id="element-3313" data-mp="xft5ekc6s77z">•</span>
                <span data-id="element-3314" data-mp="xhcjq5ea8874">
                  Two supplements in one, molecularly distilled fish oil + CoQ10
                  for enhanced absorption, NSF Certified
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3315" data-mp="9p5wbvqjbbju">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3316" data-mp="9o478ncoooj4">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3317" data-mp="ep1x7m3xqmv6">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3318" data-mp="3vyq94h9l6aeo">
                <strong data-id="element-3319" data-mp="4pszci5y8o3j">1 gelcap, 2-3 times daily</strong> with meals
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3320" data-mp="1u50t9z0a2sf2">
                450mg EPA + 180mg DHA + 30mg CoQ10 per gelcap • 90 gelcaps per
                bottle
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3321" data-mp="3v7i2vm3bdrlc">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3322" data-mp="3v6yxt5yrixoq" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3323" data-mp="3h88zxo44ctzb">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}